import React from 'react';

import UserContext from "../userContext";

import Header from './Header'
import Footer from './Footer'
import Loading from "./Loading";

export function Layout(props) {
    const [loading, setLoading] = React.useState(true)
    const [first, setFirst] = React.useState(true)

    const userContext = React.useContext(UserContext)

    React.useEffect(() => {
        if (loading && first) {
            setFirst(false)
            const update = userContext.apiReducer('fetchData')
            update
                .then(() => {
                    setLoading(false)
                })
                .catch((e) => {
                    console.log(e)
                })
        }
    }, [userContext, loading, setLoading, first, setFirst])

    return (
        <div>
            <div id="content-wrapper" className="min-vh-100">
                <Header />
                <div className="layoutContent">
                    {
                        loading
                            ? <Loading />
                            : props.children
                    }
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Layout